import { Image, Square } from '@grubhubprod/gh-cookbook-react/dist';
import classnames from 'classnames';
import React from 'react';
import { SignOutButton } from 'src/components/common/features/Signup/components/SignOutButton/SignOutButton';
import { useScreenSizes } from 'src/utilities/useScreenSizes';
import { EnterpriseBackToHomeButton } from 'src/components/EnterpriseBackToHomeButton/EnterpriseBackToHomeButton';
import { getConfig } from 'src/utilities/config';

export interface ISignupNavBarProps {
  isErrorPage?: boolean;
  isEnterprise?: boolean;
}

export default function SignupNavBar({
  isErrorPage,
  isEnterprise,
}: ISignupNavBarProps): JSX.Element {
  const { isPhone } = useScreenSizes();
  const { grubhubLogo } = getConfig();

  return (
    <Square
      as="header"
      backgroundColor={
        isEnterprise || isPhone || isErrorPage
          ? 'globals.white'
          : 'globals.transparent'
      }
      inset="md"
      dimension={isEnterprise || isPhone ? '2' : null}
      className={classnames('', {
        signupWizard_fixedHeader: isPhone || isErrorPage || isEnterprise,
      })}
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Image width="114px" src={grubhubLogo} alt="Grubhub logo" />
      {(isPhone || isErrorPage) && (
        <>{isEnterprise ? <EnterpriseBackToHomeButton /> : <SignOutButton />}</>
      )}
    </Square>
  );
}
